import { css } from '@inter-ikea-kompis/web-component';
import ImageAspectRatioEnum from '../../enums/ImageAspectRatioEnum.js';
/**
 * ImageStyle.
 */
export default class ImageStyle {
    /**
     * Returns style.
     *
     * @param imageStyleOptions ...
     * @param imageStyleOptions.isProductImage True if the image is from Ric.
     * @param imageStyleOptions.isLoading True if loading.
     * @param imageStyleOptions.aspectRatio ...
     * @param imageStyleOptions.offsetWidth ...
     * @returns Style.
     */
    static getStyle(imageStyleOptions) {
        return css `
			:host {
				width: 100%;
				object-fit: contain;
			}

			img {
				object-fit: inherit;
				width: inherit;
				height: inherit;
				opacity: ${imageStyleOptions.isLoading ? '0' : '1'};
			}

			${imageStyleOptions.isProductImage ? this.getProductImage() : ''}
			${this.getImageAspectRatioStyle(imageStyleOptions) ?? ''}
		`;
    }
    /**
     * Returns RIC style.
     *
     * @returns Ric style.
     */
    static getProductImage() {
        return css `
			:host {
				display: block;
				position: relative;
				padding-top: 100%;
				overflow: hidden;
			}
			img {
				position: absolute;
				top: 0;
				left: 0;
				bottom: 0;
				right: 0;
			}
		`;
    }
    static getImageAspectRatioStyle({ aspectRatio, offsetWidth }) {
        if (aspectRatio === ImageAspectRatioEnum.SQUARE) {
            return css `
				:host {
					object-fit: cover;
				}
				img {
					width: 100%;
					height: ${offsetWidth}px;
					object-position: center;
				}
			`;
        }
        return null;
    }
}
//# sourceMappingURL=ImageStyle.js.map